import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import './styles/qualia-tokens.css';
import './styles/resware-tokens.css';
import {OpenFeatureProvider} from '@openfeature/react-sdk';
import {validateEnvironment} from './config/env';
import {activeFile} from './stores';
import AppTheme from './theme/AppTheme';

// Validate environment configuration at startup
validateEnvironment();

// Begin mirroring the active ResWare file from the desktop host (no-op in a browser).
activeFile.initActiveFileBridge();

async function initializeApp() {
  // Deferred input so that initialization occurs.
  const {default: App} = await import('./App.tsx');

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <OpenFeatureProvider>
        <AppTheme>
          <App />
        </AppTheme>
      </OpenFeatureProvider>
    </React.StrictMode>,
  );
}

void initializeApp();
